import * as getterHelper from "../../helpers/getterHelper";

/**
 * @class StockItem
 *
 * Represents an item in stock
 */
export default class StockItem {
    /**
     * @param {Number}  currentValue    - current count of this item in stock
     * @param {String}  minValue        - minimal count of this item in stock
     * @param {String}  ordered         - sum of all orders for this items
     * @param {Number}  prediction      - predicted number for usage of this item
     * @param {Number}  itemTypeId      - specifies item
     * @param {Object}  item            - item information
     * @param {String}  database        - database name
     */
    constructor(currentValue, minValue, ordered, prediction, itemTypeId, item, database) {
        this._key = getterHelper.getStockItemKey(itemTypeId, item);
        this._currentValue = currentValue;
        this._minValue = minValue;
        this._ordered = ordered;
        this._prediction = prediction;
        this._itemTypeId = itemTypeId;
        this._item = item;
        this._database = database;

        if (this._item === null) {
            throw new Error("Invalid StockItem values");
        }
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get currentValue() {
        return this._currentValue;
    }

    set currentValue(value) {
        this._currentValue = value;
    }

    get minValue() {
        return this._minValue;
    }

    set minValue(value) {
        this._minValue = value;
    }

    get ordered() {
        return this._ordered;
    }

    set ordered(value) {
        this._ordered = value;
    }

    get prediction() {
        return this._prediction;
    }

    set prediction(value) {
        this._prediction = value;
    }

    get itemTypeId() {
        return this._itemTypeId;
    }

    set itemTypeId(value) {
        this._itemTypeId = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get database() {
        return this._database;
    }

    set database(database) {
        this._database = database;
    }

    /**
     * @return {String}
     */
    toString() {
        return "StockItem (" + this.id + ")";
    }
}
